import style from './AppIcon.module.scss';

function IconLine(){

    return(
        <div className={style.IconLine} />
    )
}

export default IconLine